module.exports = "<div style=\"height: 500px;\">\r\n    <iframe id=\"map\" ng-if=\"vm.mapUrlsLoaded\" class=\"map\" src=\"{{vm.url}}\" frameborder=\"0\" width=\"100%\" height=\"100%\" allowfullscreen prevent-scroll></iframe>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/shared/directives/bookmarks/bookmarks-map.directive.html
 ** module id = 127
 ** module chunks = 0
 **/